import React from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";
import HomeHeaderWrapper from "@fdr/home-header";
import { DerbyEventStatus, IRace } from "@fdr/types/ts/Derby";
import { HomepageConfigCTA, HomepagePromo } from "@fdr/home/src/utils/types";
import {
  getDerbyRace,
  getEventDate,
  getHomepageCTAButtons,
  getHomepageCurrentConfig,
  getHomepageEventDescription,
  getHomepageEventName,
  getHomepageEventSubtitle,
  getHomepageEventTrackAbbr,
  getHomepagePromo,
  getTodayDate
} from "@fdr/home/src/redux/selectors";

export interface MappedState {
  subtitle: string;
  showDerbyPicks: boolean;
  isNumberFire: boolean;
  trackAbbr: string;
  eventStatus: DerbyEventStatus;
  todayDate: Date;
  promo: HomepagePromo;
  derbyRace?: IRace;
  homepageCTA: HomepageConfigCTA;
  eventDate?: Date | null;
}

const defaultTitle = {
  label: "Welcome to horse racing",
  size: 18
};

const defaultSubtitle = {
  label: "",
  size: 0
};

const defaultDescription = {
  label: "Bet and watch races LIVE",
  size: 16
};

export const HomepageHeader = () => {
  const title = useSelector(getHomepageEventName);
  const subtitle = useSelector(getHomepageEventSubtitle);
  const description = useSelector(getHomepageEventDescription);

  const showDerbyPicks = useSelector((store) =>
    get(store, "capi.featureToggles.derbyPicks", false)
  );
  const isNumberFire = useSelector((store) =>
    get(store, "capi.featureToggles.headerIsNumberFire", false)
  );
  const trackAbbr = useSelector(getHomepageEventTrackAbbr);
  const derbyRace = useSelector(getDerbyRace);
  const eventStatus = useSelector(getHomepageCurrentConfig);
  const todayDate = useSelector(getTodayDate);
  const promo = useSelector(getHomepagePromo);
  const homepageCTA = useSelector(getHomepageCTAButtons);
  const eventDate = useSelector(getEventDate);

  const hasEventEnded = eventStatus === DerbyEventStatus.POST;

  return (
    <HomeHeaderWrapper
      title={hasEventEnded ? defaultTitle : title}
      subtitle={hasEventEnded ? defaultSubtitle : subtitle}
      description={hasEventEnded ? defaultDescription : description}
      isNumberFire={isNumberFire}
      trackAbbr={trackAbbr}
      showDerbyPicks={showDerbyPicks}
      eventStatus={eventStatus}
      todayDate={todayDate}
      promoLink={promo?.link}
      promoText={promo?.label}
      derbyRace={derbyRace}
      homepageCTA={homepageCTA}
      eventDate={eventDate}
    />
  );
};
